import { render, staticRenderFns } from "./CommentLoading.vue?vue&type=template&id=2a17cecc&lang=pug"
import script from "./CommentLoading.vue?vue&type=script&lang=ts"
export * from "./CommentLoading.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports